import { useRef } from "react";
import React from "react";
import "./ECLAddComment.css";
import { ECLRichTextEditor, ECLUserInfo } from "../../../../index";
import sourceOneRestRequest from "../../../../../utilities/requests/SourceOneRestRequest";

export default function ECLAddComment({ sectionId, getComments }) {
   const textRef = useRef();

   async function addComment(e, richTextRaw) {
      let text;
      if (richTextRaw !== undefined) {
         text = richTextRaw;
      } else {
         e.preventDefault();
         if (textRef.current) {
            text = textRef.current.value;
         }
      }
      let payload = {
         query_type: "comment_write",
         sectionId: sectionId,
         body: text,
      };

      await sourceOneRestRequest(payload);
      await getComments(sectionId);
      if (textRef.current) {
         textRef.current.value = "";
      }
   }
   return (
      <div className="add-comment add-comment-container">
         <ECLUserInfo hideName={true} />
         <h4>Add Comment</h4>
         <ECLRichTextEditor
            submitButtonText="Add Comment"
            uniqueId={sectionId}
            onSubmit={(richTextRaw) => addComment(null, richTextRaw)}
         />
      </div>
   );
}
